import React from 'react';
import RequestInfoGrid from './RequestInfoGrid';
import RequestPanelContainer from './RequestPanelContainer';
import Selectors from '../hooks/selectors';

const RequestPanelFull = ({
  category,
  code,
  onChange,
  url,
}) => {
  const { requestCode, requestUrl, isNew } = Selectors.useRequestPanel({ category, code, url });
  return (
    <RequestPanelContainer
      category={category}
      className="aridhia-request-panel-full panel-wizardible"
      code={requestCode}
      isNew={isNew}
      onChange={onChange}
      url={requestUrl}
    >
      <RequestInfoGrid category={category} code={requestCode} />
    </RequestPanelContainer>
  );
};

export default RequestPanelFull;
